import { Box, Divider, IconButton, Menu, MenuItem } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Check } from "@mui/icons-material";
import moment from "moment";
import SortIcon from "../../../Icons/SortIcon";

const SortSection = ({ setPdfList }: { setPdfList: any }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const [sortOrder, setSortOrder] = useState<string>("Ascending");
    const [sortType, setSortType] = useState<string>("Date");

    useEffect(() => {
        if (sortType === "Date") {
            setPdfList((prev: any) => {
                prev?.sort((a: any, b: any) => {
                    if (a?.created_at > b?.created_at) return 1;
                    if (a?.created_at < b?.created_at) return -1;
                    return 0;
                });
                return [...prev];
            });
        }
        if (sortType === "A-Z") {
            setPdfList((prev: any) => {
                prev?.sort((a: any, b: any) => {
                    if (a?.file_name > b?.file_name) return 1;
                    if (a?.file_name < b?.file_name) return -1;
                    return 0;
                });
                return [...prev];
            });
        }
    }, [sortType]);

    useEffect(() => {
        if (sortOrder === "Ascending") {
            setPdfList((prev: any) => {
                prev?.sort((a: any, b: any) => {
                    if (a?.file_name > b?.file_name) return 1;
                    if (a?.file_name < b?.file_name) return -1;
                    return 0;
                });
                return [...prev];
            });
        }
        if (sortOrder === "Descending") {
            setPdfList((prev: any) => {
                prev?.sort((a: any, b: any) => {
                    if (b?.file_name > a?.file_name) return 1;
                    if (b?.file_name < a?.file_name) return -1;
                    return 0;
                });
                return [...prev];
            });
        }
    }, [sortOrder]);

    return (
        <Box>
            <IconButton onClick={(event: React.MouseEvent<HTMLButtonElement>) => setAnchorEl(event.currentTarget)}>
                <SortIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                PaperProps={{
                    style: {
                        padding: "0px 5px",
                        width: "12rem",
                    },
                }}>
                {["Date", "A-Z"]?.map((item: string) => (
                    <MenuItem
                        sx={{
                            background: sortType === item ? "#E3F4FF" : "inherit",
                            borderRadius: "7px",
                        }}
                        onClick={() => setSortType(item)}>
                        {item}
                    </MenuItem>
                ))}
                <Divider />
                {["Ascending", "Descending"]?.map((item: string) => (
                    <MenuItem
                        sx={{
                            borderRadius: "7px",
                            justifyContent: "space-between",
                        }}
                        onClick={() => setSortOrder(item)}>
                        {item}
                        {sortOrder === item && <Check fontSize="small" sx={{ color: "#007BFF" }} />}
                    </MenuItem>
                ))}
            </Menu>
        </Box>
    );
};

export default SortSection;
